/**
 * Clase base abstracta para estrategias de token
 * Siguiendo el patrón Strategy y el principio de Inversión de Dependencias (DIP)
 */

class BaseTokenStrategy {
  /**
   * @param {Object} options - Opciones de configuración
   * @param {Object} [options.logger=console] - Logger a utilizar
   */
  constructor(options = {}) {
    this.options = options;
    this.logger = options.logger || console;
  }

  /**
   * Método abstracto para obtener token
   * @throws {Error} Si no se implementa por las subclases
   */
  async execute() {
    throw new Error('Method not implemented: las subclases deben implementar este método');
  }
  
  /**
   * Registra error en el sistema de logs y opcionalmente en localStorage
   * @protected
   * @param {string} context - Contexto del error
   * @param {Error} error - Error capturado
   */
  _logError(context, error) {
    this.logger.error(`[TokenStrategy:${context}]`, error.message || error);
    try {
      localStorage.setItem('token_strategy_error', JSON.stringify({
        context,
        message: error.message || String(error),
        timestamp: new Date().toISOString()
      }));
    } catch (e) {/* Error no crítico */}
  }
}

export default BaseTokenStrategy;
